import type { AxePurchaseState, v2 } from '@deque/billing-service-client';
import { type ProductSlugs } from '@deque/billing-utils';
import { apiRequest } from '../../api-client';

export type SubscriptionEnvironment = NonNullable<
  v2.CreateEnterpriseSubscriptionParams['environment']
>;

export interface CreateAdminSubscriptionParams {
  token: string;
  enterpriseId: string;
  product_slug: ProductSlugs | string;
  purchase_state: AxePurchaseState;
  license_count?: number | null;
  unit_count?: number;
  metrics?: v2.CreateEnterpriseSubscriptionParams['metrics'];
  start_date?: string;
  end_date?: string;
  trial_expires?: string;
  environment?: SubscriptionEnvironment;
  product_url?: string;
  sub_group?: string;
  monitor_v8?: boolean;
}

/**
 * Create a new subscription for an existing enterprise.
 * POST /api-internal/enterprise/:enterprise_id/subscriptions
 */
export function createAdminSubscription({
  token,
  enterpriseId,
  product_slug,
  purchase_state,
  license_count,
  unit_count,
  metrics,
  start_date,
  end_date,
  trial_expires,
  environment,
  product_url,
  sub_group,
  monitor_v8
}: CreateAdminSubscriptionParams): Promise<v2.EnterpriseSubscription> {
  return apiRequest({
    method: 'POST',
    endpoint: `/api-internal/enterprise/${enterpriseId}/subscriptions`,
    token,
    body: {
      product_slug,
      purchase_state,
      ...(license_count !== null &&
        license_count !== undefined && { license_count }),
      ...(unit_count !== undefined && { unit_count }),
      ...(metrics && metrics.length > 0 && { metrics }),
      ...(start_date && { start_date }),
      ...(end_date && { end_date }),
      ...(trial_expires && { trial_expires }),
      ...(environment && { environment }),
      ...(product_url && { product_url }),
      ...(sub_group && { sub_group }),
      ...(monitor_v8 && { monitor_v8 })
    }
  });
}
